import {
	ActivateTermsMutation,
	AddTermsMutation,
	CombineTermsMutation,
	DeactivateTermsMutation,
	DeleteTermsMutation,
	RevertTermsCombineMutation,
	SetDefaultTermsMutation,
	UnsetDefaultTermsMutation,
	UpdateTermsMutation
} from "~/gql/mutations/terms.generated";
import {
	GetTermsByIdQuery,
	GetTermsByNamesQuery,
	GetTermsCombinePreviewQuery,
	GetTermsMatchingNamesQuery,
	GetTermsQuery
} from "~/gql/queries/terms.generated";

export const termsEndpoints = {
	ActivateTerms: {
		invalidatesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: ActivateTermsMutation) => res
	},
	AddTerms: {
		invalidatesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: AddTermsMutation) => res
	},
	CombineTerms: {
		invalidatesTags: ["Customer", "Terms"] as AddTagTypes,
		transformResponse: (res: CombineTermsMutation) => res
	},
	DeactivateTerms: {
		invalidatesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: DeactivateTermsMutation) => res
	},
	DeleteTerms: {
		invalidatesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: DeleteTermsMutation) => res
	},
	GetTerms: {
		keepUnusedDataFor: 300,
		providesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: GetTermsQuery) => res
	},
	GetTermsById: {
		providesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: GetTermsByIdQuery) => res
	},
	GetTermsByNames: {
		providesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: GetTermsByNamesQuery) => res
	},
	GetTermsMatchingNames: {
		providesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: GetTermsMatchingNamesQuery) => res
	},
	RevertTermsCombine: {
		invalidatesTags: ["Customer", "Terms"] as AddTagTypes,
		transformResponse: (res: RevertTermsCombineMutation) => res
	},
	SetDefaultTerms: {
		invalidatesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: SetDefaultTermsMutation) => res
	},
	GetTermsCombinePreview: {
		keepUnusedDataFor: 0,
		providesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: GetTermsCombinePreviewQuery) => res
	},
	UnsetDefaultTerms: {
		invalidatesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: UnsetDefaultTermsMutation) => res
	},
	UpdateTerms: {
		invalidatesTags: ["Terms"] as AddTagTypes,
		transformResponse: (res: UpdateTermsMutation) => res
	}
};
